import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";

import { useThemeChange } from "../../../../utils/themeChange";
import { useToastContext } from "../../../../modules/toast/context";
import { getBase64 } from "../../../../utils/encodeimage";
import { useApi } from "../../../../hooks/api/useApi";
import { COLLECTION } from "../../../../constants/api-constants";
import useAuthStore from "../../../../store/authStore";
import Loading from "../../../../components/components/Loading";

const { ADD_COLLECTION } = COLLECTION;

const defaultCollection = { name: "", description: "" };

const CreateCollection = () => {
  const themeChange = useThemeChange();
  const navigate = useNavigate();
  const { showError, showSuccess } = useToastContext();
  const { post } = useApi();
  const { userData } = useAuthStore((state) => ({ userData: state.userLog }));
  const [collectionDetail, setCollectionDetail] = useState(defaultCollection);
  const [profileImage, setProfileImage] = useState("");
  const [profile, setProfile] = useState("");
  const [coverImage, setCoverImage] = useState("");
  const [cover, setCover] = useState("");

  const createCollection = useMutation({
    mutationFn: post,
    onSuccess: () => {
      // setCollectionDetail(defaultCollection);
      // setProfileImage("");
      // setProfile("");
      // setCoverImage("");
      // setCover("");
      showSuccess("Collection Successfully Created.");
    },
    onError: () => {
      showError("Collection Creation Unsuccessfull.");
    },
  });

  if (createCollection.isSuccess) {
    navigate(`/collections/${createCollection?.data?.id}`);
  }

  const onChange = (e) => {
    const { name, value } = e.target;
    setCollectionDetail((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    createCollection.mutate({
      ...collectionDetail,
      profileImage: profile,
      coverImage: cover,
      artistId: userData?.artist?.id,
      access_token: userData?.access_token,
      route: ADD_COLLECTION,
    });
  };

  return (
    <div className={themeChange.add("section")}>
      <section className="jumbotron breadcumb no-bg">
        <div className="mainbreadcumb">
          <div className="container">
            <div className="row m-10-hor">
              <div className="col-12">
                <h1 className="text-center">List Your Collection</h1>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="container">
        <div className="row">
          <div className="col-lg-7 offset-lg-1 mb-5">
            <form
              id="form-create-item"
              className="form-border"
              action=""
              onSubmit={handleSubmit}
            >
              <div className="field-set">
                <div style={{ display: "flex" }}>
                  <h5 style={{ marginRight: "10px" }}>
                    Name<span className="error-message-color">*</span>
                  </h5>
                </div>
                <input
                  required
                  type="text"
                  name="name"
                  maxLength={80}
                  id="item_name"
                  className="form-control"
                  placeholder="Name of collection"
                  onChange={onChange}
                />

                <div className="spacer-10"></div>

                <div className="spacer-10"></div>

                <h5>Description</h5>
                <textarea
                  data-autoresize
                  name="description"
                  id="item_desc"
                  className="form-control"
                  placeholder="Describe your collection"
                  onChange={onChange}
                ></textarea>

                <div className="spacer-10"></div>

                <div className="row">
                  <div className="col-lg-6 mb-4">
                    <div style={{ display: "flex" }}>
                      <h5 style={{ marginRight: "10px" }}>Profile Picture</h5>
                    </div>

                    <div className="d-create-file">
                      {profileImage && profileImage.length > 0 ? (
                        <img
                          id="close"
                          src={profileImage}
                          alt=""
                          height={200}
                          width={200}
                          style={{ marginBottom: "30px" }}
                        />
                      ) : (
                        <>
                          <p key="{index}">PNG, JPG, GIF or WEBP</p>
                        </>
                      )}
                      <div className="browse">
                        <input
                          type="button"
                          id="get_file"
                          className="btn-main"
                          value="Browse"
                        />
                        <input
                          id="upload_file"
                          type="file"
                          name="profileImage"
                          onChange={(e) => {
                            const imgSize = e.target.files[0].size;
                            if (imgSize > 5 * 1024 * 1024) {
                              showError("Image size should be less than 5MB");
                              return;
                            }
                            setProfileImage(
                              URL.createObjectURL(e.target.files[0])
                            );
                            getBase64(e.target.files[0], setProfile);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 ">
                    <h5>Cover Picture</h5>

                    <div className="d-create-file">
                      {coverImage && coverImage.length > 0 ? (
                        <img
                          id="close"
                          src={coverImage}
                          alt=""
                          height={200}
                          width={200}
                          style={{ marginBottom: "30px" }}
                        />
                      ) : (
                        <>
                          <p key="{index}">PNG, JPG, GIF or WEBP</p>
                        </>
                      )}
                      <div className="browse">
                        <input
                          type="button"
                          id="get_file"
                          className="btn-main"
                          value="Browse"
                        />
                        <input
                          id="upload_file"
                          type="file"
                          name="coverImage"
                          onChange={(e) => {
                            const imgSize = e.target.files[0].size;
                            if (imgSize > 5 * 1024 * 1024) {
                              showError("Image size should be less than 5MB");
                              return;
                            }
                            setCoverImage(
                              URL.createObjectURL(e.target.files[0])
                            );
                            getBase64(e.target.files[0], setCover);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="spacer-single"></div>
                {createCollection.isLoading ? (
                  <Loading loadingMessage="Creating your Collection" />
                ) : (
                  <input
                    type="submit"
                    id="submit"
                    className="btn-main"
                    value="Create Collection"
                    disabled={createCollection.isLoading}
                  />
                )}
              </div>
            </form>
          </div>
          {/* {window.innerWidth > 992 ? (
            <div className="col-lg-3 col-sm-6 col-xs-12">
              <h5
                style={{
                  position: "sticky",
                  top: "100px",
                  textAlign: "center",
                }}
              >
                Preview
              </h5>
              <CollectionCard
                className="d-item"
                style={{
                  position: "sticky",
                  top: "130px",
                }}
                coverImage={coverImage}
                profileImage={profileImage}
                name={formik.values.name}
                description={formik.values.description}
              />
            </div>
          ) : (
            <div className="col-lg-3 col-sm-6 col-xs-12">
              <h5 style={{ textAlign: "center" }}>Preview</h5>
              <CollectionCard
                className="d-item"
                coverImage={coverImage}
                profileImage={profileImage}
                name={formik.values.name}
                description={formik.values.description}
              />
            </div>
          )} */}
        </div>
      </section>
    </div>
  );
};

export default CreateCollection;
